import {Button, Col, Container, Modal, Row} from "react-bootstrap"

const SendingMessageModal = ({isSendingMessageModalVisible, setSendingMessageModalVisibility, messageToDisplay}) => {

    const handleClose = () => {
        setSendingMessageModalVisibility(false)
    }

    return (
        <Modal
            scrollable
            show={isSendingMessageModalVisible}
            size="lg"
            onHide={() => setSendingMessageModalVisibility(false)}
            className="justify-content-center"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="justify-content-center">
                <Modal.Title className="h5 font-weight-bold">Zamówienie projektu</Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-1">
                <Container>
                    <div className={`mt-2 align-items-center}`}>
                        <Row className="m-3">
                            <Col style={{whiteSpace: "pre-line"}}>{messageToDisplay}</Col>
                        </Row>
                    </div>
                </Container>
            </Modal.Body>

            <Modal.Footer className="p-2 shadow-lg">
                <Button variant="outline-danger" onClick={handleClose}>
                    Anuluj
                </Button>
                <Button
                    variant="outline-primary"
                    type="submit"
                    onClick={() => window.location.reload()}>
                    Zamknij
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SendingMessageModal